module.exports = __webpack_public_path__ + "img/pddl.66fb3c6b.svg";